import { api } from '../hooks/useConfigureAxios';

type PrintRequest = {
  deviceId: string;
};

export const PrintAPI = {
  print: async function (request: PrintRequest): Promise<void> {
    await api.post(
      '/data-logger/sensor/print',
      request,
      { timeout: 15000 },
    );
  },
};
